/**
 * Kids mode (docs/refactor/48): the screens a child may be on — the start ideas, the rooms and their character. Any
 * other address takes them back to the start, so a link or a shortcut never leads into the adult's settings.
 */

const ALLOWED = ['/kids', '/track/floor', '/me/character', '/terms']

export function kidsAllowed(pathname: string): boolean {
  return ALLOWED.some((path) => pathname === path || pathname.startsWith(`${path}/`))
}
